import { UploadedDocument, UploadedImage } from './CommonTypes';

// temp solution untill ImageLoader is refactored to a DocumentLoader (or similar)
export const documentToImageFormat = (
    doc: UploadedDocument
): UploadedImage => ({
    imageId: doc?.uploadedFileId,
    type: doc?.type,
    uploadedPath: doc?.filePath,
    image: doc?.file,
    filename: doc?.filename
});

export const imageToDocumentFormat = (
    doc: UploadedImage
): UploadedDocument => ({
    uploadedFileId: doc?.imageId,
    type: doc?.type,
    filePath: doc?.uploadedPath,
    file: doc?.image,
    filename: doc?.filename
});
